import React from 'react';
import { QRCodeCanvas } from 'qrcode.react';

const AppDownloadSection = () => {
    const androidLink = 'https://play.google.com/store/apps/details?id=com.assiganto';
    const iosLink = 'https://apps.apple.com/app/id000000000';

    return (
        <section className="assiganto-home-wrapper-2 py-4 bg-light">
            <div className="container-xxl">
                <div className="row text-center">
                    <div className="col-12 mb-4">
                        <h4 className="fw-bold">Téléchargez l'application ASSIGANTO AGRO</h4>
                        <p>Disponible sur Android et iOS</p>
                    </div>

                    {/* Android */}
                    <div className="col-md-6 d-flex flex-column align-items-center mb-4">
                        <QRCodeCanvas value={androidLink} size={128} />
                        <p className="mt-2">Scannez ou cliquez pour Android</p>
                        <a href={androidLink} target="_blank" rel="noopener noreferrer">
                            <img
                                src="images/providers/GetItOnGooglePlay_Badge_Web_color_English.png"
                                alt="Télécharger sur Google Play"
                                style={{ height: '50px', marginTop: '10px' }}
                            />
                        </a>
                    </div>

                    {/* iOS */}
                    <div className="col-md-6 d-flex flex-column align-items-center mb-4">
                        <QRCodeCanvas value={iosLink} size={128} />
                        <p className="mt-2">Scannez ou cliquez pour iOS</p>
                        <a href={iosLink} target="_blank" rel="noopener noreferrer">
                            <img
                                src="images/providers/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg"
                                alt="Télécharger sur l'App Store"
                                style={{ height: '50px', marginTop: '10px' }}
                            />
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AppDownloadSection;
